<div class="form-row m-0">
	<div class="form-row position-relative w-100">
		<mat-form-field appearance="outline" class="w-100">
			<input
				type="text"
				[placeholder]="placeholder"
				matInput
				[(ngModel)]="label"
				[formControl]="popPoiControl"
				[matAutocomplete]="pois"
			/>
			<mat-autocomplete #pois="matAutocomplete" (optionSelected)="emitPoiOrPop($event.option.value)">
				<cdk-virtual-scroll-viewport
					itemSize="48"
					class="autocomplete-virtual-scroll-viewport"
					cdkFixedSizeVirtualScroll
					minBufferPx="200"
					maxBufferPx="400"
					[style]="{ height: listHeight + 'px' }"
				>
					<mat-option
						*cdkVirtualFor="let option of popPoiOptions | async"
						cdkVirtualForTrackBy="trackByAddress"
						[value]="option"
						class="autocomplete-virtual-scroll-item"
					>
						{{ option.fullname || option.address }}
					</mat-option>
				</cdk-virtual-scroll-viewport>
			</mat-autocomplete>
		</mat-form-field>
	</div>
</div>
